<template>
  <v-card flat class="mt-3">
    <v-card-text class="mt-3">
      <h5>
        <v-icon size="22" class="mr-2 mb-1">$sl-ebook</v-icon>Teoripaket för denna kurs
      </h5>

      <v-data-table
        flat
        :headers="[
          { text: 'Teoripaket', value: 'name', sortable: true },
          { text: '', value: 'action', sortable: false, align: 'end' },
        ]"
        :items="courses"
        sort-by="provider"
        class="mb-4"
        hide-default-footer
      >
        <template slot="item.name" slot-scope="props">
          <div>
            <!-- <CopyToClipboard
              :text="props.item.name"
              always-visible
              @on-copy="copyCourse(props.item)"
              v-if="props.item"
            >
              <div class="title mt-2 d-flex align-center">
                {{props.item.name}}
              </div>
            </CopyToClipboard> -->
            <div class="title mt-2 d-flex align-center">
              {{props.item.name}}
            </div>
            <div class="caption mb-2" v-if="props.item.assignments && props.item.assignments.length">{{getAssignmentsText(props.item.assignments)}}</div>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn text class="mr-2 px-1" @click="deleteCourse(item.tcId)">
            <v-icon @click="deleteCourse(item.tcId)">$sl-delete</v-icon>Radera
          </v-btn>
        </template>
      </v-data-table>

      <v-btn @click="add()">
        <v-icon data-cy="add-theory-course" class="mr-2">$sl-add</v-icon>Lägg till teoripaket
      </v-btn>

      <v-dialog v-model="crudDialog" max-width="600px">
        <CreateProfessionCourseTheoryCourseModal
          v-if="crudDialog"
          :providedCourses="providedCourses"
          :has-assignments="hasAssignments"
          :courses="courses"
          @close="close"
          @save="save"
        />
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import findIndex from "lodash/findIndex";
import find from "lodash/find";
import CreateProfessionCourseTheoryCourseModal from './CreateProfessionCourseTheoryCourseModal'
// import CopyToClipboard from "@/components/common/CopyToClipboard.vue";

// @group Ebook
// Styled ProviderBookCommonTheory component
export default {
  name: "ProviderBookCommonTheory",

  components: {
    CreateProfessionCourseTheoryCourseModal,
    // CopyToClipboard
  },

  props: {
    professionId: Number,
    courseId: Number,
    hasAssignments: Boolean
  },

  data: () => ({
    providedCourses: [],
    selectedCourses: [],
    crudDialog: false,
  }),

  computed: {
    courses() {
      return this.selectedCourses.length && this.providedCourses.length
        ? this.selectedCourses.map((o) => {
            let course = find(this.providedCourses, [
              "id",
              o.distanceEducationProviderCourseId,
            ]) || { tcId: -1, id: -1, name: "Felaktigt eller borttaget kurspaket", type: -1 };
            return { tcId: o.id, id: course.id, name: course.name, assignments: o.assignments, type: course.type };
          })
        : [];
    },

    copiedCourses() {
      return JSON.parse(sessionStorage.getItem('byn4_theory_courses')) || []
    }
  },

  watch: {
    professionId: function () {
      this.getProvidedCourses(this.professionId);
    },
    courseId: function () {
      this.getSelectedCourses(this.courseId, this.professionId);
    },
  },

  created() {
    this.getProvidedCourses(this.professionId);
    this.getSelectedCourses(this.courseId, this.professionId);
  },

  methods: {
    getAssignmentsText(assignments){
      return assignments.map(a => a.name).join(', ')
    },

    /**
     * @vuese
     * Used to  get selected courses
     * @arg The arguments are  integers value representing the course id and profession id
     */
    getSelectedCourses(courseId, professionId) {
      if (!courseId || !professionId) return;

      API.listProfessionCourseTheoryCourses(courseId, professionId)
        .then((res) => {
          this.selectedCourses = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * @vuese
     * Used to  get provided courses
     * @arg The argument is an integer value representing profession id
     */
    getProvidedCourses(professionId) {
      if (!professionId) return;

      API.listDistanceEducationProviderCourses(professionId)
        .then((res) => {
          this.providedCourses = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    close() {
      this.crudDialog = false;
    },
    /**
     * @vuese
     * Used to  create profession theory courses
     * @arg The argument is an integer value representing ccourse id and data params are distanceEducationProviderCourseId and professionid
     */
    save({ distanceCourseId, assignments, type }) {
      this.crudDialog = false;

      API.createProfessionCourseTheoryCourses(this.courseId, {
        data: {
          distanceEducationProviderCourseId: distanceCourseId,
          professionId: this.professionId,
          assignments: assignments,
          type
        },
      })
        .then((res) => {
          this.selectedCourses.push(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * @vuese
     * Used to  delete profession theory courses
     * @arg The argument is an integer value representing course id and trade certification id
     */
    async deleteCourse(tcId) {
      const res = await this.$dialog.confirm({
        text: "Raderande av teoripaket går inte att ångra.",
        title: "Vill du radera detta teoripaket?",
        width: "550",
        actions: [
          { text: "Avbryt", key: false, icon: "$sl-cancel" },
          { text: "Radera", key: true, icon: "$sl-delete", outlined: true },
        ],
      });
      if (res !== true) return;

      let found = findIndex(this.selectedCourses, (o) => {
        return o.id == tcId;
      });
      if (found < 0) return;

      API.deleteProfessionCourseTheoryCourses(this.courseId, tcId)
        .then((res) => {
          this.selectedCourses.splice(found, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    add() {
      this.crudDialog = true;
    },

    copyCourse(course) {
      if ( course == null ) return
      let byn4Courses = this.copiedCourses
      if ( byn4Courses.some(crs => course.id === crs.id) ) return
      byn4Courses.push(course)
      sessionStorage.setItem('byn4_theory_courses', JSON.stringify(byn4Courses))
    }
  },
};
</script>

<style lang="scss" scoped></style>
